// Please keep this in sync between ops-tools and merchant-admin.

import { Select } from '@creditornot/cb-select';
import React, { useMemo } from 'react';
import { MenuPlacement } from 'react-select';

import { localize } from 'common/utils';

import { VatCategoryT } from './types';

export type Props = {
  vatCategories: VatCategoryT[] | undefined;
  disabled?: boolean;
  invalid?: boolean;
  menuPlacement?: MenuPlacement;
  lang: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  clearable: boolean;
};

const renderCategoryLabel = (vatCategory: VatCategoryT, lang: string): string => {
  const label = localize(vatCategory.label, lang);
  const percentage = `${vatCategory.vat_percentage}%`;
  if (label) {
    return `${label} \u2013 ${percentage}`;
  }

  return percentage;
};

const VatCategoriesSelect = ({
  vatCategories,
  disabled,
  invalid,
  menuPlacement,
  lang,
  value,
  onChange,
  clearable,
}: Props) => {
  const options = useMemo(
    () =>
      (vatCategories || [])
        .map(vatCategory => ({
          value: vatCategory.code,
          // Example: Food products – 14%
          label: renderCategoryLabel(vatCategory, lang),
        }))
        .sort((vc1, vc2) => vc1.label.localeCompare(vc2.label)),
    [vatCategories, lang],
  );

  return (
    <div>
      <Select
        disabled={disabled}
        invalid={invalid}
        menuPlacement={menuPlacement}
        options={options}
        value={value}
        onChange={newValue => onChange(newValue || undefined)}
        clearable={clearable}
      />
    </div>
  );
};

export default VatCategoriesSelect;
